module.exports = __webpack_public_path__ + "static/media/pilihan_kamu.58e3efd7.svg";